import { Inject, Injectable } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivityAuthRemoteControllerService } from 'core/api';
import { IActivityAuthDto, LAuth } from 'core/dto';
import { BehaviorSubject, take } from 'rxjs';
import { ActorAuthComponent } from '../actor-auth/actor-auth.component';
import { IActorAuthDef } from '../actor-auth/types/i-actor-auth.def';
import { IActorSplugDialogData } from '../actor-splug-info/actor-splug-info.component';

@Injectable()
export class ActorAuthChecklistService {

  readonly actorAuthDefs: IActorAuthDef[] = [
    {
      type: 'ACCESS_CODE',
      description: 'ss-process-wizard.auth.code.description',
      display: 'ss-process-wizard.auth.code.display',
      controls: [
        {
          dataField: 'value',
          label: 'ss-process-wizard.auth.code.display',
          type: 'text',
          validationRules: [
            { type: 'required' }
          ],

        },
      ]
    },
    {
      type: 'SMS_OTP',
      description: 'ss-process-wizard.auth.sms-otp.description',
      display: 'ss-process-wizard.auth.sms-otp.display',
      controls: [
        {
          dataField: 'value',
          label: 'ss-process-wizard.auth.sms-otp.mobile',
          type: 'phone',
          validationRules: [
            { type: 'required' }
          ],

        }]
    },
    {
      type: 'SXS_OTP',
      description: 'ss-process-wizard.auth.sxs-otp.description',
      display: 'ss-process-wizard.auth.sxs-otp.display',
      controls: [
        {
          dataField: 'value',
          label: 'ss-process-wizard.auth.sxs-otp.m-token',
          type: 'text',
          validationRules: [
            { type: 'required' }
          ],

        }]
    },
    // {
    //   type: 'OPEN_ID_CONNECT',
    //   description: 'ss-process-wizard.auth.oidc.description',
    //   display: 'document-download.title'
    // }
  ]


  readonly actorAuthComponentsSubject = new BehaviorSubject<ActorAuthComponent[]>([]);
  get actorAuthComponents() {
    return this.actorAuthComponentsSubject.value;
  }

  readonly selectedAuths = new Set<LAuth>();

  get isValid() {

    const allValid = this.actorAuthComponents.reduce<boolean>((isValid, actorAuth) => isValid && actorAuth.isValid, true);
    return allValid;
  }

  readonly configuredAuthsSubject = new BehaviorSubject<IActivityAuthDto[]>(null)

  get actor() {
    return this._data.actor
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) private readonly _data: IActorSplugDialogData,
    private readonly _activityAuthRemoteControllerService: ActivityAuthRemoteControllerService,
  ) {

    this._activityAuthRemoteControllerService.getConfiguredAuths(this.actor.activityId)
      .pipe(take(1))
      .subscribe(configuredAuths => {
        this.configuredAuthsSubject.next(configuredAuths)
      })
  }


  save(activityId: string) {

    const params = this.actorAuthComponents
      .filter((actorAuth) => actorAuth.checkedSubject.value)
      .map<IActivityAuthDto>((actorAuth) => {
        const { formData, name } = actorAuth.submit()
        return {
          activityId,
          params: formData,
          name
        }
      })

    if (params.length === 0) {

      return this._activityAuthRemoteControllerService.configure([{ activityId }])
    }

    return this._activityAuthRemoteControllerService.configure(params);
  }

  selectAuth(auth: LAuth) {
    this.selectedAuths.add(auth);
  }

  removeAuth(auth: LAuth) {
    this.selectedAuths.delete(auth);
  }


}
